import { Drawer as MantineDrawer, ModalBaseStylesNames } from '@mantine/core'
import { ReactNode } from 'react'
import { Button } from '../button'
import { Heading } from '../heading'
import styled from 'styled-components'

const DrawerHeading = styled(Heading)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
  width: 100%;
  line-height: 1.2;
`

const StyledDrawer = styled(MantineDrawer)`
  .mantine-Drawer-overlay {
    z-index: 1200;
  }

  .mantine-Drawer-inner {
    z-index: 1200;
    margin: 8px 0 8px 0;
  }

  .mantine-Drawer-content {
    border-radius: 8px;
    margin-right: 8px;
  }

  @media (max-width: 767px) {
    .mantine-Drawer-inner {
      margin: 0;
    }

    .mantine-Drawer-content {
      width: 100%;
      max-width: 100%;
      height: 100%;
      max-height: 100%;
      margin-right: 0;
      border-radius: 0;
    }
  }

  ${({ theme }) => `
    .mantine-Drawer-header {
      border-bottom: 1px solid ${theme.colors.gray80};
      padding-inline-end: 0px;
      padding: 0px;
      margin: 4px 12px;
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;

      .mantine-Drawer-title {
        width: calc(100% - 40px);
      }
      
      @media (min-width: 200px) {
        flex-direction: row;
      }
    }
  `}
`

export function Drawer({
  children,
  title,
  buttonText,
  position = 'right',
  isOpen = false,
  onOpen,
  onClose,
  classNames,
}: Readonly<{
  children: ReactNode
  title?: string
  buttonText?: string
  position?: 'right' | 'left'
  onOpen: () => void
  onClose: () => void
  isOpen: boolean
  classNames?: Partial<Record<ModalBaseStylesNames, string>>
}>) {
  return (
    <>
      <StyledDrawer
        opened={isOpen}
        onClose={onClose}
        title={
          title && (
            <DrawerHeading level="h3" data-testid="drawer-heading">
              {title}
            </DrawerHeading>
          )
        }
        position={position}
        closeButtonProps={{
          'aria-label': 'close-drawer',
        }}
        classNames={classNames}
      >
        {children}
      </StyledDrawer>

      {buttonText && (
        <Button variant="secondary" onClick={onOpen}>
          {buttonText}
        </Button>
      )}
    </>
  )
}
